import { Grid, GridItem } from '@chakra-ui/react';
import PageContainer from '../../components/PageContainer';
import HomeExperiences from './components/HomeExperiences';
import PreviewTop from './components/PreviewTop';
import ProjectsPreview from './components/ProjectsPreview';
import Contacts from './components/Contact';

export default function Home() {
  return (
    <PageContainer>
      <Grid
        templateColumns={{ base: '1fr', md: '1fr', lg: '1fr 1fr' }}
        width="100%"
        minH="100vh"
        placeItems="center"
      >
        <GridItem>
          <PreviewTop />
          <Contacts />
        </GridItem>
        <GridItem>
          <ProjectsPreview />
          <HomeExperiences />
        </GridItem>
      </Grid>
    </PageContainer>
  );
}
